export default {
    GET_PROGRESSBAR:(state) => {
      return state.progressBar
    },

    GET_VALUE:(state) => {
      return state.value
    },
}